export class SavingsQueryProvider {
  public validateAddressVariables(
    postcode: string,
    houseNumber: number,
    houseNumberAddition?: string
  ): object {
    return {
      postalCode: postcode,
      houseNumber,
      houseNumberAddition,
    };
  }

  public validateSavingsVariables(
    searchCriteria: object,
    _selectedFilters: object,
    credentials: object,
    sessionId: string
  ): object {
    const type = searchCriteria['productSavingType'];
    const duration =
      type === 'V_DOV' ? null : searchCriteria['duration'] || 'P2Y';

    return {
      input: {
        commonTechnical: {
          sessionId,
          senderId: credentials['clientId'],
        },
        policyDetails: {
          moneyViewSavings: {
            type,
            moneyViewInterestCollections: {
              moneyViewInterests: {
                duration,
                value: String(searchCriteria['savings']),
              },
            },
          },
        },
      },
    };
  }

  public validateSuppliersVariables(result): object {
    const productKrns = result.policyDetails?.map((item) => {
      return item.productCode;
    });

    return {
      productKrns: productKrns,
      productCategory: 'SAVINGS',
    };
  }

  public featuresVariables(
    parentProductIds: string[],
    productIds: string[],
    after: string | undefined
  ): object {
    return {
      where: {
        and: [
          {
            or: [
              {
                parentProductId: {
                  in: parentProductIds.map((id) => parseInt(id)),
                },
              },
              {
                productId: {
                  in: productIds.map((id) => parseInt(id)),
                },
              },
            ],
          },
          {
            externalFeatureId: {
              in: [
                18930, 26555, 26950, 29061, 2968, 2988, 2993, 30116, 38405,
                38722, 38774, 77303, 81256, 26550, 81254, 38410, 76379, 29075,
                4999, 5024, 5009, 5012, 5002, 5020, 2971,
              ],
            },
          },
        ],
      },
      after,
    };
  }

  public orderSavingsVariables(
    comparisonId: string,
    chosenProductKrn: string,
    senderId: string
  ): object {
    return {
      comparisonId: comparisonId,
      chosenProductKrn: chosenProductKrn,
      input: {
        commonTechnical: {
          senderId: senderId,
          googleAnalyticsId: this.getCookie('_ga'),
          googleAnalyticsSessionId: this.getCookie(
            this.getAnalyticsSessionIdCookieName()
          ),
        },
      },
      frontEndName: 'overstappen',
    };
  }

  public validateEmailVariables(
    comparisonId: string | number,
    email: string,
    productType: string
  ): object {
    return {
      comparisonId,
      email,
      productType: 'SAVINGS' || productType,
    };
  }

  private getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach((el) => {
      let [key, value] = el.split('=');
      cookie[key.trim()] = value;
    });
    return cookie[cookieName];
  }

  private getAnalyticsSessionIdCookieName = () => {
    const cookieNameStart = document.cookie.substring(
      document.cookie.indexOf('_ga_')
    );
    return cookieNameStart.substring(0, cookieNameStart.indexOf('='));
  };
}
